import bilAPI from '../api';

export const uploadImage = (body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/core/content_images/upload/`, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject('axios error');
        });
    } catch (error) {
      reject('system error');
    }
  });
};
